/**
 * @generated SignedSource<<6b06ea2b0efb92b502887c59730e5a95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedFreeShippingPill_viewer">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_viewer";
};
export type PdpSharedCondensedSidebarButtons_viewer$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isCondensedPdpRedesignVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_viewer",
  "selections": [
    {
      "condition": "isCondensedPdpRedesignVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFreeShippingPill_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e1168531b01baa1e49f671e0eb53f765";

export default node;
